import { IPROP_MAP, modifyProps } from '../../generators/modifyProps';

import { JDSTextProps } from './generated';

const legacyTextColors = [
  'primary-grey-100',
  'primary-80',
  'primary-70',
  'primary-60',
  'primary-50',
  'primary-40',
  'primary-30',
  'primary-20',
  'primary-inverse',
  'primary-background',
  'primary-grey-80',
  'primary-grey-60',
  'primary-grey-40',
  'primary-grey-20',
  'secondary-80',
  'secondary-70',
  'secondary-60',
  'secondary-50',
  'secondary-40',
  'secondary-30',
  'secondary-20',
  'secondary-inverse',
  'secondary-background',
  'secondary-grey-100',
  'secondary-grey-80',
  'secondary-grey-60',
  'secondary-grey-40',
  'secondary-grey-20',
  'sparkle-80',
  'sparkle-70',
  'sparkle-60',
  'sparkle-50',
  'sparkle-40',
  'sparkle-30',
  'sparkle-20',
  'sparkle-inverse',
  'sparkle-background',
  'sparkle-grey-100',
  'sparkle-grey-80',
  'sparkle-grey-60',
  'sparkle-grey-40',
  'sparkle-grey-20',
  'feedback-error-80',
  'feedback-error-50',
  'feedback-error-20',
  'feedback-warning-80',
  'feedback-warning-50',
  'feedback-warning-20',
  'feedback-success-80',
  'feedback-success-50',
  'feedback-success-20'
] as const;
type legacyTextColorsType = (typeof legacyTextColors)[number];

const legacyAppearance = [
  'body-s',
  'heading-xl',
  'heading-l',
  'heading-m',
  'heading-s',
  'heading-xs',
  'heading-xxs',
  'overline',
  'body-l',
  'body-l-bold',
  'body-l-link',
  'body-m',
  'body-m-bold',
  'body-m-link',
  'body-s-bold',
  'body-s-link',
  'body-xs',
  'body-xs-bold',
  'body-xs-link',
  'body-xxs',
  'body-xxs-bold',
  'body-xxs-link',
  'list-title',
  'body_xs_caps'
] as const;
type legacyAppearanceType = (typeof legacyAppearance)[number];

export interface TextProps
  extends Omit<
    JDSTextProps,
    'color' | 'appearance' | 'textType' | 'onTextlayout' | 'textAlign'
  > {
  color?: legacyTextColorsType | JDSTextProps['color'];

  appearance?: legacyAppearanceType | JDSTextProps['appearance'];
  /**
   * @deprecated
   * use `text` prop instead
   */
  children?: React.ReactNode;
  as?: 'div' | 'label' | 'p' | 'small' | 'span';
  role?: string;
  ariaDescribedby?: string;
  ariaHidden?: string;
}

export const PROP_MAP: IPROP_MAP<TextProps> = (props) => {
  if (legacyAppearance.includes(props.appearance as legacyAppearanceType)) {
    console.warn(
      'these values for appearance prop are deprecated',
      legacyAppearance
    );
  }
  if (legacyTextColors.includes(props.color as legacyTextColorsType)) {
    console.warn('these values for color are deprecated', legacyTextColors);
  }
  return {
    color: {
      properties: {},
      variations: {
        'primary-grey-100': {
          color: 'primary_grey_100'
        },
        'primary-80': {
          color: 'primary_80'
        },
        'primary-70': {
          color: 'primary_70'
        },
        'primary-60': {
          color: 'primary_60'
        },
        'primary-50': {
          color: 'primary_50'
        },
        'primary-40': {
          color: 'primary_40'
        },
        'primary-30': {
          color: 'primary_30'
        },
        'primary-20': {
          color: 'primary_20'
        },
        'primary-inverse': {
          color: 'primary_inverse'
        },

        'primary-background': {
          color: 'primary_background'
        },

        'primary-grey-80': {
          color: 'primary_grey_80'
        },

        'primary-grey-60': {
          color: 'primary_grey_60'
        },

        'primary-grey-40': {
          color: 'primary_grey_40'
        },

        'primary-grey-20': {
          color: 'primary_grey_20'
        },

        'secondary-80': {
          color: 'secondary_80'
        },

        'secondary-70': {
          color: 'secondary_70'
        },

        'secondary-60': {
          color: 'secondary_60'
        },

        'secondary-50': {
          color: 'secondary_50'
        },

        'secondary-40': {
          color: 'secondary_40'
        },

        'secondary-30': {
          color: 'secondary_30'
        },

        'secondary-20': {
          color: 'secondary_20'
        },

        'secondary-inverse': {
          color: 'secondary_inverse'
        },

        'secondary-background': {
          color: 'secondary_background'
        },

        'secondary-grey-100': {
          color: 'secondary_grey_100'
        },

        'secondary-grey-80': {
          color: 'secondary_grey_80'
        },

        'secondary-grey-60': {
          color: 'secondary_grey_60'
        },

        'secondary-grey-40': {
          color: 'secondary_grey_40'
        },

        'secondary-grey-20': {
          color: 'secondary_grey_20'
        },

        'sparkle-80': {
          color: 'sparkle_80'
        },

        'sparkle-70': {
          color: 'sparkle_70'
        },

        'sparkle-60': {
          color: 'sparkle_60'
        },

        'sparkle-50': {
          color: 'sparkle_50'
        },

        'sparkle-40': {
          color: 'sparkle_40'
        },

        'sparkle-30': {
          color: 'sparkle_30'
        },

        'sparkle-20': {
          color: 'sparkle_20'
        },

        'sparkle-inverse': {
          color: 'sparkle_inverse'
        },

        'sparkle-background': {
          color: 'sparkle_background'
        },

        'sparkle-grey-100': {
          color: 'sparkle_grey_100'
        },

        'sparkle-grey-80': {
          color: 'sparkle_grey_80'
        },

        'SPARKLE-GREY-60': {
          color: 'sparkle_grey_60'
        },

        'sparkle-grey-40': {
          color: 'sparkle_grey_40'
        },

        'sparkle-grey-20': {
          color: 'sparkle_grey_20'
        },

        'feedback-error-80': {
          color: 'feedback_error_80'
        },

        'feedback-error-50': {
          color: 'feedback_error_50'
        },

        'feedback-error-20': {
          color: 'feedback_error_20'
        },

        'feedback-warning-80': {
          color: 'feedback_warning_80'
        },

        'feedback-warning-50': {
          color: 'feedback_warning_50'
        },

        'feedback-warning-20': {
          color: 'feedback_warning_20'
        },

        'feedback-success-80': {
          color: 'feedback_success_80'
        },

        'feedback-success-50': {
          color: 'feedback_success_50'
        },

        'feedback-success-20': {
          color: 'feedback_success_20'
        },
        white: { color: 'white' },
        black: { color: 'black' },
        transparent: { color: 'transparent' }
      }
    },
    children: {
      properties: {
        text: props.text || props.children
      }
    },
    text: {
      properties: {
        text: props.text || props.children
      }
    },
    as: {
      properties: {
        textType: props.as
      }
    },
    appearance: {
      properties: {},
      variations: {
        'body-s': { appearance: 'body-s' },
        'heading-xl': { appearance: 'heading_xl' },
        'heading-l': { appearance: 'heading_l' },
        'heading-m': { appearance: 'heading_m' },
        'heading-s': { appearance: 'heading_s' },
        'heading-xs': { appearance: 'heading_xs' },
        'heading-xxs': { appearance: 'heading_xxs' },
        overline: { appearance: 'overline' },
        'body-l': { appearance: 'body_l' },
        'body-l-bold': { appearance: 'body_l_bold' },
        'body-l-link': { appearance: 'body_l_link' },
        'body-m': { appearance: 'body_m' },
        'body-m-bold': { appearance: 'body_m_bold' },
        'body-m-link': { appearance: 'body_m_link' },
        'body-s-bold': { appearance: 'body_s_bold' },
        'body-s-link': { appearance: 'body_s_link' },
        'body-xs': { appearance: 'body_xs' },
        'body-xs-bold': { appearance: 'body_xs_bold' },
        'body-xs-link': { appearance: 'body_xs_link' },
        'body-xxs': { appearance: 'body_xxs' },
        'body-xxs-bold': { appearance: 'body_xxs-bold' },
        'body-xxs-link': { appearance: 'body_xxs_link' },
        'list-title': { appearance: 'list_title' },
        button: { appearance: 'button' },
        code: { appearance: 'code' }
      }
    }
  };
};

export const withLogic =
  (Component: React.ComponentType<TextProps>): React.FC<TextProps> =>
  (userProps: TextProps) => {
    const props = modifyProps(userProps, PROP_MAP);

    return (
      <Component
        {...{
          ...props
        }}
      />
    );
  };
